import { render } from "./AddBook.vue?vue&type=template&id=ac1d40fe&scoped=true"
import script from "./AddBook.vue?vue&type=script&lang=js"
export * from "./AddBook.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ac1d40fe"

export default script